import { ResultObj, allFetch } from "../Domain";

/**
 * 車補助主項新建 參數
 * @param {string} ct_id                車型流水號
 * @param {string} ctf_id               車型規格流水號
 * @param {string} year                 年式
 * @param {string} year_age             年份
 * @param {string} valid_time_start     生效時間起
 * @param {string} valid_time_end       生效時間迄
 * @param {string} licensed_time_start  領牌時間起
 * @param {string} licensed_time_end    領牌時間迄
 * @param {string} note                 備註
 * @param {string} seq                  順序
 */
export type CarSubsidyMasterCreateParams = {
    ct_id: string,
    ctf_id: string,
    year: string,
    year_age: string,
    valid_time_start: string,
    valid_time_end: string,
    licensed_time_start: string,
    licensed_time_end: string,
    note: string,
    seq: string,
}

/**
 * @description 車補助主項新建
 */
export const CarSubsidyMasterCreate = async (params: CarSubsidyMasterCreateParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyMasterCreate', params);



/**
 * 車補助主項修改 參數
 * @param {string} csm_id               車補助主項流水號
 * @param {string} ct_id                車型流水號
 * @param {string} ctf_id               車型規格流水號
 * @param {string} year                 年式
 * @param {string} year_age             年份
 * @param {string} valid_time_start     生效時間起
 * @param {string} valid_time_end       生效時間迄
 * @param {string} licensed_time_start  領牌時間起
 * @param {string} licensed_time_end    領牌時間迄
 * @param {string} note                 備註
 * @param {string} seq                  順序
 * @param {string} visible              是否可見
 */
export type CarSubsidyMasterUpdateParams = {
    csm_id: string,
    ct_id: string,
    ctf_id: string,
    year: string,
    year_age: string,
    valid_time_start: string,
    valid_time_end: string,
    licensed_time_start: string,
    licensed_time_end: string,
    note: string,
    seq: number,
    visible: "Y" | "N",
}

/**
 * @description 車補助主項修改
 */
export const CarSubsidyMasterUpdate = async (params: CarSubsidyMasterUpdateParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyMasterUpdate', params);

/**
 * 車補助主項查詢 參數
 * @param {string} ct_id                車型流水號
 * @param {string} ctf_id               車型規格流水號
 * @param {string} year                 年式
 * @param {string} year_age             年份
 * @param {string} valid_time_start     生效時間起
 * @param {string} valid_time_end       生效時間迄
 * @param {string} licensed_time_start  領牌時間起
 * @param {string} licensed_time_end    領牌時間迄
 * @param {string} visible              是否可見
 * @param {number} page                 頁碼
 * @param {number} num_per_page         一頁幾筆
 * @param {string} excel                是否匯出              
 */
export type CarSubsidyMasterSearchParams = {
    ct_id: string,
    ctf_id: string,
    year: string,
    year_age: string,
    valid_time_start: string,
    valid_time_end: string,
    licensed_time_start: string,
    licensed_time_end: string,
    note: string,
    visible: "Y" | "N",
    page: number,
    num_per_page: number,
    excel: "Y" | "N"
}

export type CarSubsidyMasterSearchResItem = {
    csm_id: string,
    ct_id: string,
    car_type: string,
    car_type_name: string,
    ctf_id: string,
    format_code: string,
    format_name: string,
    year: string,
    year_age: string,
    valid_time_start: string,
    valid_time_end: string,
    licensed_time_start: string,
    licensed_time_end: string,
    note: string,
    visible: "Y" | "N",
    seq: number
}

/**
 * @description 車補助主項查詢
 */
export const CarSubsidyMasterSearch = async (params: CarSubsidyMasterSearchParams): Promise<ResultObj<CarSubsidyMasterSearchResItem[]>> =>
    await allFetch('CarSubsidy/CarSubsidyMasterSearch', params);

/**
 * 車補助主項細項 參數
 * @param {string} csm_id 車補助主項流水號
 */
export type CarSubsidyMasterDetailParams = {
    csm_id: string,
}

export type CarSubsidyMasterDetailResItem = {
    car_type: string;
    csm_id: string;
    ct_id: string;
    ctf_id: string;
    format_code: string;
    licensed_time_end: string;
    licensed_time_start: string;
    note: string;
    seq: number;
    valid_time_end: string;
    valid_time_start: string;
    visible: "Y" | "N";
    year: string;
    year_age: string;
}

/**
 * @description 車補助主項細項
 */
export const CarSubsidyMasterDetail = async (params: CarSubsidyMasterDetailParams): Promise<ResultObj<CarSubsidyMasterDetailResItem[]>> =>
    await allFetch('CarSubsidy/CarSubsidyMasterDetail', params);

/**
 * 車補助主項刪除 參數
 * @param {string} csm_id 車補助主項流水號
 */
export type CarSubsidyMasterDeleteParams = {
    csm_id: string,
}

/**
 * @description 車補助主項刪除
 */
export const CarSubsidyMasterDelete = async (params: CarSubsidyMasterDeleteParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyMasterDelete', params);



/**
 * 車補助細項新建 參數
 * @param {string}  csm_id 車補助主項流水號
 * @param {string}  csc_id 車補助條件流水號
 * @param {number}  price  金額
 */
export type CarSubsidyDetailCreateParams = {
    csm_id: string,
    csc_id: string,
    price: number,
}

/**
 * @description 車補助細項新建
 */
export const CarSubsidyDetailCreate = async (params: CarSubsidyDetailCreateParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyDetailCreate', params);

/**
 * 車補助細項修改 參數
 * @param {string} csd_id  車補細項流水號
 * @param {string} price   金額
 * @param {string} visible 是否可見
 */
export type CarSubsidyDetailUpdateParams = {
    csd_id: string,
    price: number,
    visible: string,
}

/**
 * @description 車補助細項修改
 */
export const CarSubsidyDetailUpdate = async (params: CarSubsidyDetailUpdateParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyDetailUpdate', params);

/**
 * 車補助細項查詢 參數
 * @param {string} csd_id       車補細項流水號
 * @param {number} page         頁碼
 * @param {number} num_per_page 一頁幾筆
 */
export type CarSubsidyDetailSearchParams = {
    csm_id: string,
    page: number,
    num_per_page: number,
}

export type CarSubsidyDetailSearchResItem = {
    abnormal_sale_type: string;
    associate_csc_ids: string;
    associate_type: "成立" | "不成立"
    basic_count: number;
    basic_unit_id: string;
    basic_unit_name: string;
    category: "現金" | "配件";
    commodity_code: string;
    commodity_id: string;
    commodity_name: string;
    convert_count: number;
    convert_unit_id: string;
    convert_unit_name: string;
    cs_id: string;
    csc_id: string;
    csd_id: string;
    csm_id: string;
    deductible: "可折" | "不可折";
    discount: number;
    documet_source: string;
    label_big: string;
    label_big_name: string;
    note: string;
    price: number;
    price_source_csc_id: string;
    uc_id: string;
    visible: "Y" | "N" | "";
}

/**
 * @description 車補助細項查詢
 */
export const CarSubsidyDetailSearch = async (params: CarSubsidyDetailSearchParams): Promise<ResultObj<CarSubsidyDetailSearchResItem[]>> =>
    await allFetch('CarSubsidy/CarSubsidyDetailSearch', params);

/**
 * 車補助細項查詢 參數
 * @param {string} csd_id 車補細項流水號
 */
export type CarSubsidyDetailDetailParams = {
    csm_id: string,
}

/**
 * @description 車補助細項查詢
 */
export const CarSubsidyDetailDetail = async (params: CarSubsidyDetailDetailParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyDetailDetail', params);

/**
 * 車補助細項刪除 參數
 * @param {string} csd_id 車補細項流水號
 */
export type CarSubsidyDetailDeleteParams = {
    csd_id: string,
}

/**
 * @description 車補助細項刪除
 */
export const CarSubsidyDetailDelete = async (params: CarSubsidyDetailDeleteParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyDetailDelete', params);


/**
 * @description 
 * @author Daniel Wang
 * category 現金 | 配件
 * category 是現金 的時候，type 的選項會是 不指定|限定車身碼|保險
 * category 是現金 & type 是保險，就會要選類型是保險的配件，放到cct_id 和 cc_id
 * category 是現金 & type 是限定車身碼，就要查車來放cs_id
 * name 看情況，比較沒有限制，如果選了配件可以直接放配件名稱，如果選限定車身碼，可以放車身碼在這
 */

// 現今的規則
export type CarSubsidyConditionRuleCash = {
    category: "現金";
    type: "不指定" | "限定車身碼" | "保險" | ""
}

// 配件的規則
export type CarSubsidyConditionRuleComponent = {
    category: "配件";
    type: ""
}

// 限制 車補助條件用
export type CarSubsidyConditionRules =
    {
        associate_type: "成立" | "不成立",
        deductible: "可折" | "不可折" | "",
        visible: "Y" | "N" | ""
    } &
    ({ category: "", type: "" } |
        CarSubsidyConditionRuleCash |
        CarSubsidyConditionRuleComponent)

/**
 * 車補助條件新建 參數
 * @param {string} documet_source       文案來源
 * @param {string} category             分類
 * @param {string} type                 類型
 * @param {string} name                 品項
 * @param {string} label_big            配件類型流水號
 * @param {string} commodity_id         配件流水號
 * @param {string} uc_id                單位轉換流水號
 * @param {string} cs_id                車流水號
 * @param {string} associate_type       關聯類型(成立不成立
 * @param {string[]} associate_csc_ids  關聯車補助條件流水號們
 * @param {string} abnormal_sale_type   異常銷售種類
 * @param {string} deductible           可折不可折
 * @param {string} price_source_csc_id  金額來源車補助條件流水號
 * @param {string} discount             折扣
 * @param {string} note                 備註
 * @param {string} insurance_type       保險種類
 */
export type CarSubsidyConditionCreateParams = CarSubsidyConditionRules & {
    deductible: "可折" | "不可折";
    documet_source: string;
    name: string;
    label_big: string;
    commodity_id: string;
    uc_id: string;
    cs_id: string;
    associate_csc_ids: string[];
    abnormal_sale_type: string;
    price_source_csc_id: string;
    discount: string;
    note: string;
    visible: "Y" | "N";
    insurance_type: string;
}

/**
 * @description 車補助條件新建
 */
export const CarSubsidyConditionCreate = async (params: CarSubsidyConditionCreateParams): Promise<ResultObj<string>> =>
    await allFetch('CarSubsidy/CarSubsidyConditionCreate', params);

/**
 * 車補助條件修改 參數
 * @param {string} csc_id               車補助條件流水號
 * @param {string} documet_source       文案來源
 * @param {string} category             分類
 * @param {string} type                 類型
 * @param {string} name                 品項
 * @param {string} label_big            配件類型流水號
 * @param {string} commodity_id         配件流水號
 * @param {string} uc_id                單位轉換流水號
 * @param {string} cs_id                車流水號
 * @param {string} associate_type       關聯類型(成立不成立
 * @param {string[]} associate_csc_ids  關聯車補助條件流水號們
 * @param {string} abnormal_sale_type   異常銷售種類
 * @param {string} deductible           可折不可折
 * @param {string} price_source_csc_id  金額來源車補助條件流水號
 * @param {string} discount             折扣
 * @param {string} note                 備註
 * @param {string} visible              是否可見
 * @param {string} insurance_type       保險種類
 */
export type CarSubsidyConditionUpdateParams = CarSubsidyConditionRules & {
    csc_id: string;
    documet_source: string;
    name: string;
    label_big: string;
    commodity_id: string;
    uc_id: string;
    cs_id: string;
    associate_csc_ids: string[];
    abnormal_sale_type: string;
    price_source_csc_id: string;
    discount: number;
    note: string;
    visible: "Y" | "N";
    insurance_type: string;
}

/**
 * @description 車補助條件修改
 */
export const CarSubsidyConditionUpdate = async (params: CarSubsidyConditionUpdateParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyConditionUpdate', params);

/**
 * 車補助條件查詢 參數
 * @param {string} documet_source       文案來源
 * @param {string} category             分類     
 * @param {string} type                 類型(現金|配件)    
 * @param {string} name                 品項     
 * @param {string} abnormal_sale_type   異常銷售種類(SPP)
 * @param {string} deductible           可折不可折()  
 * @param {string} note                 備註     
 * @param {string} visible              是否可見
 */
export type CarSubsidyConditionSearchParams = {
    documet_source: string;
    name: string;
    abnormal_sale_type: string;
    note: string;
    page: string;
    num_per_page: string;
} & Partial<CarSubsidyConditionRules>

export type CarSubsidyConditionSearchResItem = {
    abnormal_sale_type: string;
    associate_csc_ids: string;
    associate_type: "成立" | "不成立";
    basic_count: number;
    basic_unit_id: string;
    basic_unit_name: string;
    category: string;
    commodity_id: string;
    convert_count: number;
    convert_unit_id: string;
    convert_unit_name: string;
    cs_id: string;
    csc_id: string;
    deductible: "可折" | "不可折";
    discount: number;
    documet_source: string;
    label_big: string;
    name: string;
    note: string;
    price_source_csc_id: string;
    type: string;
    uc_id: string;
    visible: "Y" | "N";
    insurance_type: string;
} & CarSubsidyConditionRules

/**
 * @description 車補助條件查詢
 */
export const CarSubsidyConditionSearch = async (params: CarSubsidyConditionSearchParams): Promise<ResultObj<CarSubsidyConditionSearchResItem[]>> =>
    await allFetch('CarSubsidy/CarSubsidyConditionSearch', params);

/**
 * 車補助條件細項 參數
 * @param {string[]} csc_ids 車補助條件流水號
 */
export type CarSubsidyConditionDetailParams = {
    csc_ids: string[];
}

export type CarSubsidyConditionDetailResItem = {
    abnormal_sale_type: string;
    associate_csc_ids: string;
    basic_count: number;
    basic_unit_id: string;
    basic_unit_name: string;
    commodity_id: string;
    convert_count: number;
    convert_unit_id: string;
    convert_unit_name: string;
    cs_id: string
    csc_id: string;
    discount: number;
    documet_source: string;
    label_big: string;
    name: string;
    note: string;
    price_source_csc_id: string;
    uc_id: string;
    insurance_type: string;
} & CarSubsidyConditionRules

/**
 * @description 車補助條件細項
 */
export const CarSubsidyConditionDetail = async (params: CarSubsidyConditionDetailParams): Promise<ResultObj<CarSubsidyConditionDetailResItem[]>> =>
    await allFetch('CarSubsidy/CarSubsidyConditionDetail', params);

/**
 * 車補助條件刪除 參數
 * @param {string} csc_id 車補助條件流水號
 */
export type CarSubsidyConditionDeleteParams = {
    csc_id: string;
}

/**
 * @description 車補助條件刪除
 */
export const CarSubsidyConditionDelete = async (params: CarSubsidyConditionDeleteParams): Promise<ResultObj> =>
    await allFetch('CarSubsidy/CarSubsidyConditionDelete', params);

